"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvolveAbilityHandler = exports.EvolveActorAbilityFactory = exports.EvolveAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const enums_1 = require("../../core/enums");
class EvolveAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Evolve;
        this.__typeName = "Evolve";
    }
}
exports.EvolveAbilityArgs = EvolveAbilityArgs;
let EvolveActorAbilityFactory = class EvolveActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Evolve", "OneAllies", 0);
    }
};
EvolveActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Evolve")
], EvolveActorAbilityFactory);
exports.EvolveActorAbilityFactory = EvolveActorAbilityFactory;
let EvolveAbilityHandler = class EvolveAbilityHandler {
    constructor() {
        this.primaryAttrs = Array.from(enums_1.PRIMARY_ATTRIBUTES)
            .concat(enums_1.AttributeType.Health);
        this.imms = [
            enums_1.AttributeType.ChaosDamageImmunity,
            enums_1.AttributeType.DeathDamageImmunity,
            enums_1.AttributeType.FireDamageImmunity,
            enums_1.AttributeType.FrostDamageImmunity,
            enums_1.AttributeType.HolyDamageImmunity,
            enums_1.AttributeType.NatureDamageImmunity,
            enums_1.AttributeType.PhysicalDamageImmunity,
            enums_1.AttributeType.SonicDamageImmunity,
        ];
        this.incrs = [
            enums_1.AttributeType.ChaosDamagePercentIncrease,
            enums_1.AttributeType.DeathDamagePercentIncrease,
            enums_1.AttributeType.FireDamagePercentIncrease,
            enums_1.AttributeType.FrostDamagePercentIncrease,
            enums_1.AttributeType.HolyDamagePercentIncrease,
            enums_1.AttributeType.NatureDamagePercentIncrease,
            enums_1.AttributeType.PhysicalDamagePercentIncrease,
            enums_1.AttributeType.SonicDamagePercentIncrease,
        ];
        this.effects = Array.of((container, _, targetId) => new core_1.RegenerationEffectArgs("Evolve", container.getPercentOfMaxHealth(targetId, (0, Random_1.random)(5, 15))), (container, _, targetId) => {
            const attr = (0, Random_1.randomElement)(Array.from(enums_1.PRIMARY_ATTRIBUTES));
            return new core_1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(targetId, attr, (0, Random_1.random)(10, 15)));
        }, () => {
            const attr = (0, Random_1.randomElement)(this.imms);
            return new core_1.MaxAttributeIncreaseEffectArgs(attr, (0, Random_1.random)(1, 5));
        }, () => {
            const attr = (0, Random_1.randomElement)(this.incrs);
            return new core_1.MaxAttributeIncreaseEffectArgs(attr, (0, Random_1.random)(5, 25));
        }, () => new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 1), () => new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalDamageMultiplier, (0, Random_1.random)(5, 25)), () => new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Haste, (0, Random_1.random)(1, 5)), () => new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalDamageReductionPercent, (0, Random_1.random)(5, 25)), () => new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingIncrease, (0, Random_1.random)(5, 25)));
    }
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        const withers = container.getEffectsOfType(targetId, EffectType_1.EffectType.Withering)
            .map(eid => container.getEffect(eid));
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                sequence = sequence
                    .push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "BeamFromTheHeavens"));
                container.applyBuffs({
                    sequence: sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    effects: withers.flatMap(wither => [
                        {
                            duration: Duration_1.Duration.Instant,
                            effect: new core_1.RemoveSpecificEffectEffectArgs(wither.id),
                        },
                        {
                            duration: Duration_1.Duration.Turns(4),
                            // 3% chance to get extra actions
                            effect: (0, Random_1.randomPercentTo)(1) <= 3 ? new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.ExtraActions, 1)
                                : (0, Random_1.randomElement)(this.effects)(container, ability.invokerId, targetId)
                        }
                    ])
                });
            }
        });
    }
};
EvolveAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Evolve)
], EvolveAbilityHandler);
exports.EvolveAbilityHandler = EvolveAbilityHandler;
